import {Component, ViewContainerRef} from '@angular/core';
import {Router} from '@angular/router';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Configuration} from '../../shared/services/configuration';
import {HttpClientCustom} from '../../shared/services/http.client';
import * as _ from 'underscore';
import {Location} from '@angular/common';
import {SharedData} from '../../shared/sharedData';
import {ToasterComponent} from '../../toasterComponent/toasterComponent';
import {TranslateService} from '@ngx-translate/core';


@Component({
    selector: 'add-Users-To-Roles-Component',
    templateUrl: 'addUsersToRole.html'
})
export class AddUsersToRolesComponent {
    public _baseUrl: any;
    public selectedOption: any = 'everyone';
    public roleId: any;
    public empCodes: any = '';
    public deleteEmpCodes: any = [];
    public invalidEmployeeCodes: any = [];
    public disableButton:any=false;
    public type="";
    public showLoading: any = true;
    //pagination variables  and default values
    public pageSize: any = 10;
    public page = 1;
    public startingPage: any = 1;
    public endingPage: any = 10;
    public collectionSize: any;
    public trackHides = null;
    public roles: any = 1;
    public employeeData: any= [];
    public disabledButton: any = false;
    public employeePageData: any = {};
    public searchData = {
        "nameOrCodeOrEmail": "",
        "employeeCodes": [],
        "excludedEmployeeCodes": [],
        "includeEmpIds": [],
        "excludeEmpIds": [],
        "gradeIds": [],
        "mgrLevelIds": [],
        "designationIds": [],
        "categoryIds": [],
        "includeOrgIds": [],
        "excludeOrgIds": [],
        "supervisorIds": [],
        "primarySupervisorIds": [],
        "primarySupervisorNameOrCode": null,
        "primarySupervisorCods": [],
        "employeeStatus": null,
        "employeesWithOutSupervisor": null,
        "scorecardStates": null,
        "memberShipState": null,
        "programId": null,
        "pageSize": 10,
        "page": 1,
        "fetchSupervisorLevels": 0
    }
    constructor(
        public _global: Configuration,
        public http: HttpClientCustom, public router: Router,
        public _toaster: ToasterComponent,
        public modalService: NgbModal,
        public activeModal: NgbActiveModal,
        public share: SharedData,
        public _http: HttpClientCustom,
        public _location: Location,
        public translate:TranslateService,
        vcr: ViewContainerRef) {
        this._baseUrl = _global.get("EPMS_BASE_URL");
        let data: any = this.share.getData();
        if(_.isEmpty(data)){
            this._location.back();
        }
        else
        {
        this.roleId=data.id;
        this.type = data.type;
        if(this.type=="DELETEROLE")
        {
         this.getEmployeeDetails();
        }
        this._toaster.setViewRef(vcr);
    }
    }

     //show and hide Advance Search option
     showAdvanced() {
         
        this.share.saveAsMap('Role',  this.roleId);
        this.router.navigate(['menu/employeeSearch']);
    }

    rolesBack() {
        this._location.back();
    }

    addUsers() {
        this.invalidEmployeeCodes = [];
        if (this.selectedOption == 'everyone') {
            this.finalAddUsers('assignRoleToAllEmployees');
        }
        if (this.selectedOption == 'except') {
            this.searchData.excludedEmployeeCodes=[];
            if (this.validateEmpCodes()) {
                this.finalAddUsers('assignRolesExcludeEmployeeCodes');
            }
        }
        if (this.selectedOption == 'everyoneIn') {
            this.searchData.employeeCodes=[];
            if (this.validateEmpCodes()) {
                this.finalAddUsers('assignRolesIncludeEmployeeCodes');
            }

        }
    }
    removeUsers() {
        this.invalidEmployeeCodes = [];
        this.deleteEmpCodes=[];
            if (this.validateEmpCodes()) {
                this.finalRemoveUsers();
            }
      
    }

    finalRemoveUsers() {
        let that = this;
        that.disableButton = true;
        
        let url = that._baseUrl + 'v1/webAdmin/role/' + that.roleId;
        that.http.post(url, that.deleteEmpCodes).subscribe((result) => {
            that.disableButton = false;
            if (result.success) {
                this.translate.get('usersRoleRemoved').subscribe((msg)=>{
                that._toaster.showSuccess(msg);
                setTimeout(() => { that.rolesBack() }, 1000);
                })
                
            } else {
                that._toaster.showError(result.errorMessages[0]);
                if (result.invalidEmployeeCodes.length > 0) {
                    that.getInvalidEmpCode(result.invalidEmployeeCodes);
                }
            }
        });
    }
    public clicked() {
    }

    //pagination functions
  onPageChange(event: number): void {
    let that = this;
    if (event == 1) {
      that.startingPage = 1;
      that.endingPage = 10;
    } else {
      that.startingPage = 1 + that.pageSize;
      if (that.collectionSize > that.endingPage) {
        that.endingPage = event + that.endingPage;
      } else {
        that.endingPage = that.collectionSize;
      }
    }
    that.page = event;
    that.getEmployeeDetails();
  }
  OnPageSizeChanged(val) {
    this.pageSize = val;
    this.getEmployeeDetails();
  }

  getEmployeeDetails() {
        try {
            let that = this;
            let url = that._baseUrl + 'v1/webAdmin/role/getEmployeeInfoByRoleId/'+this.roleId;
            that._http.post(url, this.searchData).subscribe((result) => {
                that.disabledButton = false;
                that.employeeData = result.content;
                that.employeePageData = result;
                if (that.employeeData.length == 0) {
                    that.showLoading = false;
                }

                that.collectionSize = result.totalElements;
                if (result.last) {
                    that.endingPage = that.collectionSize;
                }
            });
          } catch (e) {
            console.log('caught error in getCompleteRolesAndPermissionDetails', e);
          }
    }

    finalAddUsers(option) {
        let that = this;
        let flag = false;
        
        that.disableButton = true;
        let url = that._baseUrl + 'v1/webAdmin/role/' + option + '/' + that.roleId;
        that.http.post(url, that.searchData).subscribe((result) => {
            that.disableButton = false;
            if (option == 'assignRoleToAllEmployees') {
                if (result) {
                    flag = true;
                }
            } else {
                if (result.status) {
                    flag = true;
                }
            }
            if (flag) {
                this.translate.get('addedUser').subscribe((msg)=>{
                    that._toaster.showSuccess(msg);
                });
                setTimeout(() => { that.rolesBack() }, 1000);
            } else {
                that._toaster.showError(result.errorMessages[0]);
                if (result.invalidEmployeeCodes.length > 0) {
                    that.getInvalidEmpCode(result.invalidEmployeeCodes);
                }
            }
        });
    }
    validateEmpCodes() {
        let that = this;
        if (that.empCodes.trim() == '' || that.empCodes.length == 0) {
            this.translate.get('pleaseEnterEmpToContinue').subscribe((msg)=>{
                that._toaster.showError(msg);
            });
            
            return false;
        } else {
            let empCode = that.empCodes.split(',');
            _.each(empCode, function (key, val) {
                if (that.selectedOption == 'everyoneIn') {
                    that.searchData.employeeCodes.push(key.trim());
                }
                 if (that.selectedOption == 'except') {
                    that.searchData.excludedEmployeeCodes.push(key.trim());
                }
                if(that.selectedOption == 'everyone')
                {
                    that.deleteEmpCodes.push(key.trim());
                }
            
            });
        }
        return true;
    }
    getInvalidEmpCode(invalidEmployeeCodes) {
        let that = this;
        _.each(invalidEmployeeCodes, function (val, key) {
            that.invalidEmployeeCodes.push(val);
        });
    }
    selectOption(option) {
        this.selectedOption = option;
        this.invalidEmployeeCodes=[];
    }

}



// WEBPACK FOOTER //
// ./src/app/tools/rolesAndPermission/addUsersToRole.ts